import React from 'react'
import PropTypes from 'prop-types'
import styled, { css } from 'styled-components'

const StyledWrapper = styled.div`
  padding: 36px 24px;

  ${({ overflow }) =>
    overflow &&
    css`
      overflow: hidden;
    `}

  ${({ theme }) => theme.media.desktop} {
    padding: 88px 0px;
    min-height: 576px;
    ${({ small }) =>
      small &&
      css`
        min-height: initial;
      `}
    display: flex;
    align-items: center;
    justify-content: center;
  }

  ${({ fullWidth }) =>
    fullWidth &&
    css`
      ${StyledContainer} {
        ${({ theme }) => theme.media.desktop} {
          padding: 0;
          flex-wrap: nowrap;
        }
      }
    `}
`

const StyledContainer = styled.div`
  padding: 0;
  flex-wrap: wrap;
  width: 100%;
  ${({ centered }) =>
    centered &&
    css`
      display: flex;
      flex-direction: column;
      align-items: center;
    `}
  ${({ theme }) => theme.media.desktop} {
    padding: 0 calc(8.333333% - 24px);
    flex-wrap: nowrap;
  }
`

const StyledPartnersContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  > div {
    width: 100%;
    margin: 16px 0;

    > a > img {
        max-width: 200px;
    }
  }

  ${({ theme }) => css`
    ${theme.media.tablet} {
        flex-direction: row;
        flex-wrap: wrap;

        > div {
            flex-basis: 33%;
            flex-grow: 1;
        }
  `}

  }
`

const FeaturedPartners = props => {
  const { fullWidth, overflow, small, centered, children } = props
  const textHeader = children.filter(child => child.props.tag === 'textHeader')
  const partners = children.filter(child => child.props.tag === 'imageLink')

  return (
    <StyledWrapper fullWidth={fullWidth} overflow={overflow} small={small}>
      <StyledContainer centered={centered}>
        {textHeader}
        <StyledPartnersContainer>{partners}</StyledPartnersContainer>
      </StyledContainer>
    </StyledWrapper>
  )
}

FeaturedPartners.propTypes = {
  fullWidth: PropTypes.bool,
  overflow: PropTypes.bool,
  small: PropTypes.bool,
  centered: PropTypes.bool,
  children: PropTypes.node.isRequired,
}

export default FeaturedPartners
